import { ActionColumnFormat } from './ColumnsFormatters/ActionColumnFormat';
import { StatusColumnFormat } from './ColumnsFormatters/StatusColumnFormat';

export const columns = (onEye, onDelete, onRepeat, disableBoton) => [
	{
		dataField: 'usuario',
		text: 'Clave',
		classes: ' text-center',
	},
	{
		dataField: 'nombre',
		text: 'Nombre',
		classes: 'text-center',
	},
	{
		dataField: 'apellidoPaterno',
		text: 'Apellido Paterno',
		classes: 'text-center',
	},
	{
		dataField: 'apellidoMaterno',
		text: 'Apellido Materno',
		classes: 'text-center',
	},
	{
		dataField: 'profile',
		text: 'Perfil',
		classes: 'text-center',
	},
	{
		dataField: 'fechaCreacion',
		text: 'Fecha de Alta',
		classes: 'text-center',
	},
	{
		dataField: 'fechaUltimoAcceso',
		text: 'Fecha de Último Ingreso',
		classes: 'text-center',
	},
	{
		dataField: 'fechaBaja',
		text: 'Fecha de Baja',
		classes: 'text-center',
	},
	{
		dataField: 'estatus',
		text: 'Estatus',
		formatter: StatusColumnFormat,
	},
	{
		dataField: 'id',
		text: 'Acciones',
		classes: 'text-center',
		headerClasses: 'text-center',
		style: { minWidth: '137px' },
		formatter: ActionColumnFormat,
		formatExtraData: {
			onEye,
			onDelete,
			onRepeat,
			disableBoton,
		},
	},
];
